import { Component } from "react";
import { Formik } from "formik";

import {
  isEmpty,
  TextInput,
  TextArea,
  scrollToTop,
  intlShape,
  withIntl,
} from "lcm-iot-commons";

type OwnProps = {
  intl: intlShape;
  initialValues?: $TSFixMe;
  showDebugButtons?: boolean;
  takenNames?: string[];
};

const defaultProps: Partial<OwnProps> = {
  initialValues: {},
  takenNames: [],
  showDebugButtons: false,
};

type Props = OwnProps & typeof defaultProps;

export class ClientApplicationForm extends Component<Props> {
  // eslint-disable-next-line react/static-property-placement
  static readonly defaultProps = defaultProps;

  form: $TSFixMe;

  constructor() {
    // @ts-expect-error TS(2554) FIXME: Expected 1-2 arguments, but got 0.
    super();
    /* istanbul ignore next */
    this.validateForm = this.validateForm.bind(this);
    this.renderForm = this.renderForm.bind(this);
    this.setErrors = this.setErrors.bind(this);
    this.setSubmitting = this.setSubmitting.bind(this);
    this.submit = this.submit.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
  }

  /* istanbul ignore next */
  setErrors(errors: $TSFixMe) {
    // called in parent components
    this.form.setErrors(errors);
  }

  /* istanbul ignore next */
  setSubmitting(value: $TSFixMe) {
    // called in parent components
    this.form.setSubmitting(value);
  }

  validateForm(values: $TSFixMe) {
    const { intl, takenNames } = this.props;
    const errors = {};
    scrollToTop();
    if (isEmpty(values.name) || isEmpty(values.name.trim())) {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      (errors as $TSFixMe).name = intl.t`validation.name.mandatory`;
    } else if (values.name.length > 60) {
      (errors as $TSFixMe).name = intl.formatMessage(
        { id: "validation.name.too_long" },
        { characters: 60 },
      );
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    } else if (takenNames.includes(values.name)) {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      (errors as $TSFixMe).name = intl.t`api.error.client_application.taken`;
    }
    return errors;
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  submit() {
    this.form.setStatus("submitted");
    this.form.handleSubmit({});
    return Object.keys(this.validateForm(this.form.values)).length === 0;
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  values() {
    // called in parent components
    return this.form.values;
  }

  renderForm(props: $TSFixMe) {
    const { intl, showDebugButtons } = this.props;
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.form = props;

    return (
      <form onSubmit={this.onSubmit} id="client-application-form" noValidate>
        <TextInput
          {...props}
          id="client-application-name"
          name="name"
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          label={intl.t`label.name`}
          required
          autoFocus
        />
        <TextArea
          {...props}
          id="client-application-description"
          name="description"
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          label={intl.t`label.description`}
        />
        <TextArea
          {...props}
          id="redirect-uri-description"
          name="redirectURIs"
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          label={intl.t`label.redirect_uris`}
        />
        {showDebugButtons && (
          <button
            type="button"
            onClick={this.submit}
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          >{intl.t`button.submit`}</button>
        )}
        {showDebugButtons && (
          <textarea
            data-testid="debug"
            defaultValue={JSON.stringify(this.values(), null, 2)}
          />
        )}
      </form>
    );
  }

  render() {
    const { initialValues } = this.props;
    return (
      <Formik
        initialValues={initialValues}
        validate={this.validateForm}
        onSubmit={() => {}}
      >
        {this.renderForm}
      </Formik>
    );
  }
}

export default withIntl(ClientApplicationForm);
